import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Button from '../../components/buttons/Button';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import { Link } from 'react-router-dom';
import { BiChevronDown, BiChevronUp, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import fasalam from '../../assets/icons/fasalam.jpg';
import ConfirmModal from '../../components/popups/confirmationModal/ConfirmModal';
import { AiFillDelete } from 'react-icons/ai';
import { Edit } from '@mui/icons-material';
import { deleteTemplateItemOp, getMarketingCampaign } from '../../services/notification_campaign';

function NotificationCampaign() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [typeFilterStatus, setTypeFilterStatus] = useState("");
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedItem, setExpandedItem] = useState(null);

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getMarketingCampaign(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleTypeFilterChange = (value) => {
        setTypeFilterStatus(value);
        if (value !== typeFilterStatus) {
            fetchData(`?type=${value}&search=${searchText}`);
        }
    };

    const handleSearch = (value) => {
        setSearchText(value);
        fetchData(`?search=${value}&type=${typeFilterStatus}`);
    };

    const resetFilters = () => {
        setTypeFilterStatus("");
        fetchData("");
    };

    const [openingItem, setOpeningItem] = useState(null);
    const [modalIsDeleteOpen, setIsDeleteOpen] = useState(false);

    const openDeleteModal = (item) => {
        setOpeningItem(item);
        setIsDeleteOpen(true);
    };

    // Close modal
    const closeDeleteModal = () => {
        setIsDeleteOpen(false);
        setOpeningItem(null);
    };

    const deletePost = (isConfirmDelete) => {
        if (isConfirmDelete) {
            deleteTemplateItem(openingItem.id);
            closeDeleteModal();
        }
    };

    const deleteTemplateItem = async (templateItemId) => {
        try {
            let res = await deleteTemplateItemOp(templateItemId);
            if (res.status === 204) {
                fetchData("");
                closeDeleteModal();
                toast.success("Banner deleted successfully");
            } else {
                toast.error("Unable to delete Forum");
            }
        } catch (error) {
            console.error("Error deleting Forum:", error);
        }
    };

    return (
        <div className="container mx-auto px-4 py-4">
            <div className="flex flex-col space-y-4">
                {/* Header Section */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                    <div>
                        <Breadcrumbs items={[
                            { name: 'Home', link: '/dashboard' },
                            { name: 'Notifications', link: -1 },
                            { name: 'Notification Campaign' },
                        ]} />
                        <h1 className="text-xl font-bold text-gray-800 mt-1">Notification Campaigns</h1>
                    </div>
                    <Link
                        to="/notification/notification-campaing/add"
                        className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded text-sm font-medium transition-colors"
                    >
                        Create Campaign
                    </Link>
                </div>

                {/* Main Content */}
                {loading ? (
                    <div className="flex justify-center items-center h-40">
                        <CustomLoading size={60} />
                    </div>
                ) : (
                    <div className="space-y-3">
                        {data?.length > 0 ? (
                            data.map((item, index) => (
                                <div key={index} className="bg-green-300 rounded-md border border-gray-200 overflow-hidden">
                                    <div
                                        className="px-4 py-3 flex justify-between items-center cursor-pointer hover:bg-green-400"
                                        onClick={() => setExpandedItem(expandedItem === index ? null : index)}
                                    >
                                        <h3 className="font-medium text-gray-800">{item.category}</h3>
                                        {expandedItem === index ? (
                                            <BiChevronUp className="text-gray-500" />
                                        ) : (
                                            <BiChevronDown className="text-gray-500" />
                                        )}
                                    </div>

                                    {expandedItem === index && (
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-3 border-t">
                                            {item.data.map((campaign, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`border rounded-md overflow-hidden ${campaign.last_run_in_48_hours ? 'bg-gray-300 grayscale' : 'bg-white'}`}
                                                >
                                                    <div className="relative aspect-video bg-gray-100">
                                                        <img
                                                            src={campaign.image ?? fasalam}
                                                            alt={campaign.title}
                                                            className="w-full h-full object-contain"
                                                        />
                                                        <div className="absolute top-2 right-2 flex space-x-1">
                                                            <Link
                                                                to="/notification/notification-campaing/edit"
                                                                state={campaign}
                                                                className="p-1.5 bg-white rounded shadow hover:bg-gray-100"
                                                            >
                                                                <Edit className="text-blue-600" fontSize="small" />
                                                            </Link>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openDeleteModal(campaign);
                                                                }}
                                                                className="p-1.5 bg-white rounded shadow hover:bg-gray-100"
                                                            >
                                                                <BiTrash className="text-red-600" size={16} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="p-3 space-y-2">
                                                        <div className="flex justify-between">
                                                            <h4 className="font-medium text-sm line-clamp-1">{campaign.title}</h4>
                                                            <span className="text-xs bg-gray-100 px-2 py-0.5 rounded">
                                                                {campaign.banner_type}
                                                            </span>
                                                        </div>
                                                        <p className="text-xs text-gray-600 line-clamp-2">
                                                            {campaign.body || 'No description'}
                                                        </p>
                                                        <Link
                                                            to={`/notification/notification-campaing/view/${campaign.id}`}
                                                            state={campaign}
                                                            className="text-xs text-primary hover:underline inline-block"
                                                        >
                                                            View details
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="bg-white rounded-md border border-gray-200 p-6 text-center">
                                <div className="text-gray-400 mx-auto w-12 h-12">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <p className="mt-2 text-sm text-gray-600">No campaigns found</p>
                                <Link
                                    to="/notification/notification-campaing/add"
                                    className="mt-3 inline-block text-sm bg-primary hover:bg-primary-dark text-white px-3 py-1.5 rounded"
                                >
                                    Create your first campaign
                                </Link>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <ConfirmModal
                isOpen={modalIsDeleteOpen}
                onRequestClose={closeDeleteModal}
                contentLabel="Delete Campaign"
                onClose={closeDeleteModal}
                setIsConfirmDelete={deletePost}
                title="Delete this campaign?"
                subtitle="This action cannot be undone."
                icon={<AiFillDelete className="text-red-500 mx-auto" size={32} />}
                confirmText="Delete"
                cancelText="Cancel"
                confirmButtonStyle="bg-red-500 hover:bg-red-600 text-white"
            />
        </div>
    );
}

export default NotificationCampaign;